/* eslint-disable */
export default {
  noResultFoundFor: 'No se encontraron resultados para',
  foundFromServerHint:
    'Escriba la palabra clave y presione Entrar para buscar en{appName}',
  notResultFoundFromServer: 'No se encontraron resultados',
  loading: 'cargando...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
